// ministry-overview.component.ts
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import * as L from 'leaflet';

@Component({
  selector: 'app-ministry-overview',
  templateUrl: './ministry-overview.component.html',
  styleUrls: ['./ministry-overview.component.scss']
})
export class MinistryOverviewComponent implements OnInit {

  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;

  map1Options: any;
  map2Options: any;
  private map1: L.Map;
  private map2: L.Map;

  constructor(private _formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', ]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', ]
    });
    this.thirdFormGroup = this._formBuilder.group({
      thirdCtrl: ['', ]
    });

    this.map1Options = {
      layers: [
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        })
      ],
      zoom: 13,
      center: L.latLng(51.505, -0.09)
    };

    this.map2Options = {
      layers: [
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        })
      ],
      zoom: 13,
      center: L.latLng(38, 22)
    };
  }

  onMapReady1(map: L.Map) {
    this.map1 = map;
    this.initializeMap(this.map1);
    this.map1.on('click', (e: L.LeafletMouseEvent) => this.onMapClick(e, 'map1'));
  }

  onMapReady2(map: L.Map) {
    this.map2 = map;
    this.initializeMap(this.map2);
    this.map2.on('click', (e: L.LeafletMouseEvent) => this.onMapClick(e, 'map2'));
  }

  initializeMap(map: L.Map) {
    setTimeout(() => {
      if (map) {
        map.invalidateSize();
        map.on('zoomend', () => {
          const zoomLevel = map.getZoom();
          console.log('Current Zoom Level:', zoomLevel);
        });
      }
    }, 0);
  }

  onMapClick(e: L.LeafletMouseEvent, mapId: string) {
    const latlng = e.latlng;

    if (mapId === 'map1') {
      this.addMarker(this.map1, latlng);
    } else if (mapId === 'map2') {
      this.addMarker(this.map2, latlng);
    }
  }

  addMarker(map: L.Map, latlng: L.LatLng) {
    L.marker(latlng).addTo(map);
  }

  onSubmit() {
    console.log('Form submitted');
  }

}
